import React from 'react';

import classnames from 'classnames';

import { StaticImage } from '@nxte-nl/static-image';

import hand_1 from '../../images/hands/large/hand_1.webp';
import hand_2 from '../../images/hands/large/hand_2.webp';
import hand_3 from '../../images/hands/large/hand_3.webp';
import { LayoutExtension } from '../../types/ResponsiveState';
import styles from './HandV1.module.css';

export let counter = 0;

export const CARD_HANDS = [
  {
    cssClass: styles.hand1Container,
    alt: 'hand_1',
    url: hand_1,
    [LayoutExtension.DesktopLarge]: {
      width: 180,
      height: 333,
    },
    [LayoutExtension.DesktopSmall]: {
      width: 180,
      height: 333,
    },
    [LayoutExtension.Tablet]: {
      width: 195,
      height: 410,
    },
    [LayoutExtension.Mobile]: {
      width: 120,
      height: 222,
    },
  },
  {
    cssClass: styles.hand2Container,
    alt: 'hand_2',
    url: hand_2,
    [LayoutExtension.DesktopLarge]: {
      width: 100,
      height: 300,
    },
    [LayoutExtension.DesktopSmall]: {
      width: 100,
      height: 300,
    },
    [LayoutExtension.Tablet]: {
      width: 120,
      height: 360,
    },
    [LayoutExtension.Mobile]: {
      width: 83,
      height: 220,
    },
  },
  {
    alt: 'hand_3',
    cssClass: styles.hand3Container,
    url: hand_3,
    [LayoutExtension.DesktopLarge]: {
      width: 200,
      height: 410,
    },
    [LayoutExtension.DesktopSmall]: {
      width: 200,
      height: 410,
    },
    [LayoutExtension.Tablet]: {
      width: 195,
      height: 410,
    },
    [LayoutExtension.Mobile]: {
      width: 120,
      height: 246,
    },
  },
];

export const AMOUNT_OF_HANDS = 3;

export type GetImageParams = {
  height: number;
  url: string;
  width: number;
};

export const hooks = {
  useCounter() {
    counter++;
    return counter;
  },
};

// NOTE: this component fully depends on ProductCard component
export type Props = {
  layoutExtension: LayoutExtension;
};
export const HandV1 = React.memo((props: Props) => {
  const { layoutExtension } = props;

  const counter = hooks.useCounter();
  const hand = CARD_HANDS[counter % AMOUNT_OF_HANDS];
  const {
    width,
    height,
  } = hand[layoutExtension];

  return (
    <div className={classnames(styles.handContainer, hand.cssClass, {
      [styles['desktop-small']]: layoutExtension === LayoutExtension.DesktopSmall,
      [styles.mobile]: layoutExtension === LayoutExtension.Mobile,
      [styles.tablet]: layoutExtension === LayoutExtension.Tablet,
    })}>
      <StaticImage
        alt={hand.alt}
        width={width}
        height={height}
        src={hand.url}
      />
    </div>
  );
});

HandV1.displayName = 'HandV1';
